/**
 * Rota `/admin/mapa-de-acesso` (E1 Fase B).
 *
 * Como `/admin/perfis` e `/admin/home-widgets`, é tela admin meta e NÃO é
 * registrada em `system_modules` — registrar poluiria o catálogo e exigiria
 * health check sem ganho.
 */

import { lazy } from "react";

import { ModuleRoutes } from "../types";

const AccessMapPage = lazy(() => import("@/pages/admin/AccessMapPage"));

export const adminAccessMapRoutes: ModuleRoutes = {
  moduleId: "admin_access_map",
  basePath: "/admin/mapa-de-acesso",
  routes: [
    {
      path: "/admin/mapa-de-acesso",
      element: <AccessMapPage />,
      permission: { resource: "mapa_acesso", action: "manage" },
    },
  ],
};
